import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './utils';

interface Receipt {
  file_url: string;
}

export const receiptApi = createApi({
  reducerPath: 'receiptApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getReceipt: builder.query<Receipt, number | null>({
      query: (id) => ({
        url: `/v1/credits/report/purchase/${id}/receipt`,
      }),
    }),
  }),
});

export const { useGetReceiptQuery } = receiptApi;
